import axios from "axios";
import qs from "qs";
import { HttpService } from "@sportal/api";

import { resetUser, setSessionExpired } from "../../pages/login/login.actions";
import { ModalService } from "../../components/modal";
import { getSessionExpirationURL } from "../../store/config.selectors";
import { sessionStorageProxy, SessionStorageKeys } from "../../services";

export const makeHttpService = (): HttpService =>
  axios.create({
    xsrfHeaderName: "X-CSRF-TOKEN",
    xsrfCookieName: "CSRF-TOKEN",
    paramsSerializer: (params) => qs.stringify(params),
  });

export const applyBusinessNameRequestHeader = (http: HttpService, store) =>
  http.interceptors.request.use((requestConfig) => {
    const { businessName } = store.getState().accountSettings;

    if (businessName) {
      requestConfig.headers.common["X-Business-Name"] = businessName;
    }

    return requestConfig;
  });

const sessionExpired = (error) => {
  const codes = [401, 403];
  const statusCode = error.response && error.response.status;

  return codes.includes(statusCode);
};

export function applySessionExpirationInterceptor(http: HttpService, store) {
  http.interceptors.response.use(
    (response) => response,
    (error) => {
      const { getState, dispatch } = store;
      const state = getState();

      const sessionExpirationUrl = getSessionExpirationURL(state);
      const currentPage = window.location.hash.substring(1);

      if (currentPage !== "/login" && sessionExpired(error)) {
        sessionStorageProxy.setItem(SessionStorageKeys.ExpiredUrl, currentPage);
        sessionStorageProxy.removeItem(SessionStorageKeys.Reports);

        if (sessionExpirationUrl) {
          window.location.assign(sessionExpirationUrl);
          ModalService.modalReject();
        } else {
          dispatch(resetUser());
          dispatch(setSessionExpired());
          ModalService.modalReject();
        }
      }

      return Promise.reject(error);
    }
  );
}
